import { render } from "./TopThree.vue?vue&type=template&id=2edab46b&scoped=true&ts=true"
import script from "./TopThree.vue?vue&type=script&lang=ts"
export * from "./TopThree.vue?vue&type=script&lang=ts"

import "./TopThree.vue?vue&type=style&index=0&id=2edab46b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edab46b"]])

export default __exports__